import { render, staticRenderFns } from "./Anotacoes.vue?vue&type=template&id=66fd112f&scoped=true&"
import script from "./Anotacoes.vue?vue&type=script&lang=js&"
export * from "./Anotacoes.vue?vue&type=script&lang=js&"
import style0 from "./Anotacoes.vue?vue&type=style&index=0&id=66fd112f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fd112f",
  null
  
)

export default component.exports